module.exports = __webpack_public_path__ + "static/img/manual-47.424edff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-47.png
// module id = YpHX
// module chunks = 4